<div class="alert-container">
    <div class="content-section">
        @switch (currentStep()) {
        @case (1) {
        <ng-container *ngTemplateOutlet="headerContainer"></ng-container>
        <form class="form-container" [formGroup]="form">
            @for (frequencyKey of frequencyKeys; track frequencyKey) {
            <div class="option-container" [class.selected]="frequency === frequencyKey"
                [class.disabled]="frequencyKey === 'weekly'" (click)="selectFrequency(frequencyKey)">
                <div class="option-content">
                    <div class="option-text">
                        <div class="option-title">{{ alertFrequencyMap[frequencyKey].name }}</div>
                        <div class="option-description">{{ alertFrequencyMap[frequencyKey].description }}</div>
                    </div>
                    <div class="option-indicator">
                        @if (frequency === frequencyKey) {
                        <div class="checkmark">
                            <img [src]="'svg/checkmark.svg' | assetVersion">
                        </div>
                        } @else if (frequencyKey === 'weekly') {
                        <div class="coming-soon">Coming Soon</div>
                        }
                    </div>
                </div>
            </div>
            }
        </form>
        }
        @case (2) {
        <ng-container *ngTemplateOutlet="headerContainer"></ng-container>
        <form class="form-container brand-selection-form" [formGroup]="form">
            <app-brand-selection-table [data]="myBrandsAndCompetitors" [selectedBrands]="brands"
                (brandSelectionChange)="selectBrand($event)">
            </app-brand-selection-table>
        </form>
        }
        @case (3) {
        <ng-container *ngTemplateOutlet="headerContainer"></ng-container>
        <form class="form-container" [formGroup]="form">
            @for (metricKey of metricKeys; track metricKey) {
            <div class="option-container" [class.selected]="metric === metricKey" (click)="selectMetric(metricKey)">
                <div class="option-content">
                    <div class="option-text">
                        <div class="option-title">{{ alertMetricMap[metricKey].name }}</div>
                        <div class="option-description">{{ alertMetricMap[metricKey].description }}</div>
                    </div>
                    <div class="option-indicator">
                        @if (metric === metricKey) {
                        <div class="checkmark">
                            <img [src]="'svg/checkmark.svg' | assetVersion">
                        </div>
                        }
                    </div>
                </div>
            </div>
            }
        </form>
        }
        @case (4) {
        <ng-container *ngTemplateOutlet="headerContainer"></ng-container>
        <div class="review-container">
            <div class="review-header">
                <div class="header-title">{{ title }}</div>
                <div class="header-description">{{ description }}</div>
            </div>
            <div class="review-content">
                <div class="review-item">
                    <div class="item-label">Frequency</div>
                    @if (frequency && alertFrequencyMap[frequency]) {
                    <div class="item-value">{{ alertFrequencyMap[frequency].name }}</div>
                    }
                </div>
                <div class="review-item">
                    <div class="item-label">My Brands</div>
                    <div class="brands-container">
                        @if (brands && brands.length > 0) {
                        @for (brand of getMyBrandsForReview(); track brand) {
                        <span class="item-value">{{ brand }}</span>
                        }
                        }
                    </div>
                </div>
                <div class="review-item">
                    <div class="item-label">Competitors</div>
                    <div class="brands-container">
                        @if (brands && brands.length > 0) {
                        @for (brand of getCompetitorsForReview(); track brand) {
                        <span class="item-value">{{ brand }}</span>
                        }
                        }
                    </div>
                </div>
                <div class="review-item">
                    <div class="item-label">Metric</div>
                    @if (metric && alertMetricMap[metric]) {
                    <div class="item-value">{{ alertMetricMap[metric].name }}</div>
                    }
                </div>
            </div>
        </div>
        }
        }
    </div>
    <div class="bottom-section">
        <button class="button previous-button" (click)="goToPreviousStep()">
            <img [src]="'svg/arrow-left-white.svg' | assetVersion"> Back
        </button>
        @if (currentStep() < totalSteps) { <button class="button next-button" (click)="goToNextStep()"
            [class.disabled]="!canProceedToNextStep">
            Next <img [src]="'svg/arrow-right-white.svg' | assetVersion">
            </button>
            } @else {
            <button class="button submit-button" (click)="submit()">
                Update & Activate <img [src]="'svg/checkmark.svg' | assetVersion">
            </button>
            }
    </div>
</div>

<ng-template #headerContainer>
    <div class="header-container">
        <div class="header-top">
            <div class="icon"><img [src]="'svg/bell.svg' | assetVersion"></div>
            <div class="title-container">
                <span class="title">{{ title }}</span>
                <span class="divider">|</span>
                <span class="subtitle">{{ alertStepsMap[currentStep()].name }}</span>
            </div>
            <div class="alert-steps">{{ currentStep() }}/{{ totalSteps }}</div>
        </div>
        <div class="header-description">
            <span>{{ alertStepsMap[currentStep()].description }}</span>
            @if (alertStepsMap[currentStep()].subDescription) {
            <span class="sub-description">{{ alertStepsMap[currentStep()].subDescription }}</span>
            }
        </div>
    </div>
</ng-template>